export const ALL_LOCALES = [
  "da_DK",
  "en_US",
  "de_DE",
  "nb_NO",
  "sv_SE",
  "pt_PT",
  "fi_FI",
  "pl_PL",
  "nl_NL",
  "es_ES",
  "fr_FR",
] as const

export type Locale = (typeof ALL_LOCALES)[number]

export const DEFAULT_LOCALE: Locale = "en_US"

export function getIntlLocale(locale: string): string {
  return locale.replace("_", "-")
}

/**
 * Type guard function to check if a string is a valid Locale
 */
export function isValidLocale(value: string): value is Locale {
  return (ALL_LOCALES as readonly string[]).includes(value)
}
